<template>
    <label class="form-switch">
        <input type="checkbox" :name="name" :id="id||name" :true-value="trueValue" :false-value="falseValue" :checked="checked_value" :disabled="!editable" @change="input_action">
        <i class="form-icon"></i><slot></slot>
    </label>
</template>

<script type="text/javascript">
import switch_input_mixin from "./switch_input_mixin"

export default {
    name: "SwitchInput",
    mixins: [switch_input_mixin],
    methods: {
        /** Triggered when input changes
         * @event input
         * @type {Event}
         */
        input_action (event) {
            const value = event.target.checked ? this.trueValue : this.falseValue
            this.$emit("input", value)
        }
    },
    computed: {
        checked_value () {
            if(!this.modelObject || (this.checked !== null)) return !!this.checked
            return this.modelObject[this.name] === this.trueValue
        }
    }
}
</script>
